// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"998209e0","667":"2021337a","977":"db8eda7f"}[chunkId] + ".chunk.js";
};